import React, { FunctionComponent } from "react"

type WBGrid = {
  className?: string
}

const WBGrid: FunctionComponent<WBGrid> = ({ children, className = "" }) => (
<div className={`wb-content-grid ${className}`}>{children}</div>
)
export default WBGrid